import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/adminManagement/admin/List'
import Detail from 'containers/pages/adminManagement/admin/Detail'
import Form from 'containers/pages/adminManagement/admin/Form'

const Admin = ({ location, match, currentUser }) => {
  if (location.pathname === '/admin-management/admin') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-user-role-managementuser-roles-read') > -1) {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }

  if (match.params.id && location.pathname.includes('/detail')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-user-role-managementuser-roles-read') > -1) {
      return <Detail match={match} location={location} />
    }
    return <ForbiddenPage />
  }

  if (location.pathname.includes('/edit') || location.pathname.includes('/add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-user-role-managementuser-roles-write') > -1) {
      return <Form match={match} location={location} />
    }
    return <ForbiddenPage />
  }
  return ''
}

Admin.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Admin
